import { useCacheState } from '@Store/slices/cache'
import { useIntercom } from 'react-use-intercom'

function IntercomInitializer({
  children,
}: {
  children: JSX.Element
}): JSX.Element {
  const { boot, update } = useIntercom()

  const { me } = useCacheState()

  if (me && me?.intercom_user_hash) {
    update({
      userHash: me.intercom_user_hash,
      name: me.name,
      email: me.email,
      userId: me.id.toString(),
      createdAt: me.date_registered,
      customAttributes: {
        ismine_url: me.url,
        phone: me.phone,
        is_channel_based: Boolean(
          me.monitoring_source === 'PRISYNC_ENGINE',
        ).toString(),
      },
    })
  } else {
    boot()
  }

  return children
}

export default IntercomInitializer
